import axios from "../axiosInstance";

export const getNotificationEmails = async (userWarehouseId) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `warehouse/notification-email/get${
        userWarehouseId ? `?user_warehouse_id=${userWarehouseId}` : ""
      }`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error };
  }
  return response;
};

export const storeNotificationEmail = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`warehouse/notification-email/store`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error };
  }
  return response;
};

export const updateNotificationEmail = async (id, data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(
      `warehouse/notification-email/update/${id}`,
      data
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error };
  }
  return response;
};

export const deleteNotificationEmail = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.delete(
      `warehouse/notification-email/delete/${id}`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error };
  }
  return response;
};
